import { map } from "lodash";
import { GenPreviewBloc } from "../GenPreviewBloc";
import { ComponentConfig } from "../Constants";
import styles from "./Header.module.scss";

type OutputsProps = {
  bloc: GenPreviewBloc;
};

export function Outputs(props: OutputsProps) {
  return (
    <div className={styles.outputWrapper}>
      {map(props.bloc.outputs.value, (value, index) => (
        <img key={index} src={ComponentConfig[value]} />
      ))}
    </div>
  );
}
